import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-component',
    templateUrl: './loading-component.component.html',
    styleUrls: ['./loading-component.component.css']
})
export class LoadingComponentComponent implements OnInit {

    @Input()
    fetchingInProgress: string;

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/loading-component/loading-component.component.ts